import { BehaviorSubject, from, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, switchMap } from "rxjs/operators";

import { MsalService } from "@azure/msal-angular";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";

import { environment } from "src/environments/environment";

import { User } from "../../models/Identity/user";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  private loginEndPoint = `${environment.apiUrlCap}/api/login`;
  private storageTokenKey = "token";
  private userSubject: BehaviorSubject<User> = new BehaviorSubject(
    JSON.parse(localStorage.getItem("IUsr")!)
  );
  public userObservable: Observable<User> = this.userSubject.asObservable();

  public isUserLogged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public isUserLoggedObs: Observable<boolean> =
    this.isUserLogged.asObservable();

  private userToken: string | null =
    localStorage.getItem(this.storageTokenKey) ?? null;

  constructor(
    private http: HttpClient,
    private usersService: UsersService,
    private authMSService: MsalService
  ) {}

  public get currentUserValue(): User {
    return this.userSubject.value;
  }

  public get UserLocalStorage() {
    const userName = localStorage.getItem("displayName");
    return userName ?? "";
  }

  public get currentUserToken() {
    return this.userToken;
  }

  public clearUserData() {
    localStorage.clear();
    this.userSubject.next(null!);
    this.isUserLogged.next(false);
  }
  public logout(): void {
    this.clearUserData();
    this.authMSService.logoutRedirect({
      postLogoutRedirectUri:
        environment.Azure.ActiveDirectory.RedirectUriLogout,
    });
  }

  public loginToGetToken(email: string) {
    return this.http
      .post<ResponseDataInterfaces<string>>(this.loginEndPoint, { email })
      .pipe(
        map(({ data }) => {
          localStorage.setItem(this.storageTokenKey, data);
          this.userToken = data;
          return data;
        })
      );
  }

  private setUserLogged(usr: User) {
    const UserLogged = new User({
      id: usr.id,
      name: usr.name,
      email: usr.email,
      createdDate: usr.createdDate,
      fkIdRol: usr.fkIdRol,
      isHeadDevelopment: usr.isHeadDevelopment,
      homeLocation: usr.homeLocation,
      personNumber: usr.personNumber,
      personNumberHeadDevelopment: usr.personNumberHeadDevelopment,
      numberPersonNationalLeader: usr.numberPersonNationalLeader,
      fkIdCountry: usr.fkIdCountry,
      fkIdFunctionalArea: usr.fkIdFunctionalArea,
      fkIdSubarea: usr.fkIdSubarea,
      fkIdRegion: usr.fkIdRegion,
      fkIdSede: usr.fkIdSede,
      fkIdOrganization: usr.fkIdOrganization,
      headDevelopment: usr.headDevelopment
        ? {
            ...usr.headDevelopment,
          }
        : undefined,
    });
    localStorage.setItem("IUsr", JSON.stringify(UserLogged));
    localStorage.setItem("displayName", usr.name);
    localStorage.setItem("email", usr.email);
    this.userSubject.next(UserLogged);
  }

  /**
   * User already logged whit AD , manage internal data info
   */

  public internalLogin(email: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      // get and set auth token
      from(this.loginToGetToken(email))
        .pipe(
          switchMap(token => {
            return this.usersService.getUserByEmail(email);
          })
        )
        .subscribe({
          next: usr => {
            if (!usr) {
              reject(false);
              return;
            }
            this.setUserLogged(new User(usr));
            this.isUserLogged.next(true);
            resolve(true);
          },
          error: error => {
            reject(false);
          },
        });
    });
  }
}
